// Stable color per model_id, computed from an FNV-1a hash so the same model
// always gets the same color across pages — no central registry needed and
// new models slot in automatically.
//
// Hues are picked from the unit circle; saturation and lightness are fixed
// to values that stay readable against the #0b1220 dark background.

function fnv1a(str: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return h >>> 0;
}

export function modelColor(modelId: string): string {
  const h = fnv1a(modelId) % 360;
  // Saturation 70%, lightness 60% — bright enough to read on dark theme,
  // not so saturated that adjacent colors blur together.
  return `hsl(${h}, 70%, 60%)`;
}
